import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Layout from "../components/Layout";
import MediaCard from "../components/MediaCard";
import api from "../lib/api";
import { useZoom } from "../context/ZoomContext";

export default function Search() {
  const [sp, setSp] = useSearchParams();
  const [q, setQ] = useState(sp.get("q") || "");
  const [results, setResults] = useState([]);
  const [searched, setSearched] = useState(false);
  const [loading, setLoading] = useState(false);
  const { gridClass } = useZoom();

  const run = async (term) => {
    if (!term.trim()) { setResults([]); return; }
    setLoading(true);
    try {
      const r = await api.get("/media", { params: { q: term.trim(), limit: 200 } });
      setResults(r.data || []);
      setSearched(true);
    } finally { setLoading(false); }
  };

  useEffect(() => {
    const term = sp.get("q");
    if (term) { setQ(term); run(term); }
  }, [sp]);

  const submit = (e) => {
    e.preventDefault();
    setSp({ q });
    run(q);
  };

  return (
    <Layout>
      <section className="px-4 md:px-6 pt-10 pb-6">
        <div className="label-overline mb-3">// Query the archive</div>
        <h1 className="heavy text-5xl sm:text-6xl md:text-8xl">
          <span className="underline-yellow">Search</span>.
        </h1>
        <p className="mono text-[12px] text-ink-muted mt-4 max-w-[54ch]">
          Full-text keyword search across titles, descriptions, tags, authors, AK-IDs and the extracted contents of PDFs.
        </p>
        <form onSubmit={submit} className="mt-8 flex items-center gap-3 max-w-3xl">
          <input
            data-testid="search-input"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder='e.g. "ufo 1960s" or "group b rally"'
            className="input-mono flex-1"
            autoFocus
          />
          <button data-testid="search-submit" type="submit" className="pill pill-yellow">Execute →</button>
        </form>
      </section>

      <section className="px-2 md:px-3 pb-16">
        {loading && <div className="mono text-ink-muted px-4">// scanning…</div>}
        {!loading && !searched && (
          <div className="mono text-[12px] uppercase tracking-[0.14em] text-ink-muted px-4">// enter a query above</div>
        )}
        {!loading && searched && (
          <>
            <div className="label-overline mb-4 px-4" data-testid="search-results-count">// {results.length} hits</div>
            {results.length > 0 && (
              <div data-testid="search-results-grid" className={`grid ${gridClass} gap-2 md:gap-3`}>
                {results.map((m) => <MediaCard key={m.id} media={m} />)}
              </div>
            )}
          </>
        )}
      </section>
    </Layout>
  );
}
